import { motion } from "framer-motion";
import Reveal from "@/components/Reveal";

const areas = [
  "Abandonment issues", "Abuse", "ADHD", "Anger management", "Anxiety", "Bereavement",
  "Borderline personality disorder (BPD)", "Career counselling", "Childhood anxiety",
  "Complex PTSD", "Depression", "Domestic abuse", "Emotional abuse", "Family issues",
  "Feeling sad", "Generalised anxiety disorder (GAD)", "Learning disabilities",
  "LGBTQ+ counselling", "Loneliness", "Low self-confidence", "Low self-esteem",
  "Mental health", "Narcissistic abuse", "Panic attacks", "Perfectionism",
  "Pet bereavement", "Physical abuse", "Race and racial identity", "Racism",
  "Relationship problems", "Separation and divorce", "Separation anxiety",
  "Sexual abuse", "Social anxiety", "Stress", "Trauma", "Work-related stress",
];

const container = { hidden: {}, show: { transition: { staggerChildren: 0.018 } } };
const chip = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};

const Areas = () => (
  <section id="areas" className="py-20 md:py-32" data-testid="areas-section">
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
      <Reveal>
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.22em] text-[#8C827A]">Areas of work</p>
        <h2 className="max-w-2xl font-serif text-3xl font-normal tracking-tight text-[#2C2825] sm:text-4xl lg:text-5xl">
          What we can <span className="italic text-[#C46B4E]">explore together</span>
        </h2>
        <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-[#5E564F] sm:text-lg">
          Whatever brings you to therapy, you are welcome here. These are some of the
          experiences and difficulties I regularly work with.
        </p>
      </Reveal>

      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-60px" }}
        className="mt-12 flex max-w-5xl flex-wrap gap-2.5"
        data-testid="areas-chip-list"
      >
        {areas.map((a) => (
          <motion.span
            key={a}
            variants={chip}
            className="cursor-default rounded-full border border-[#E3DCD3] bg-white px-4 py-2 text-sm text-[#5E564F] transition-colors duration-300 hover:border-[#C46B4E]/60 hover:text-[#2C2825]"
          >
            {a}
          </motion.span>
        ))}
      </motion.div>
    </div>
  </section>
);

export default Areas;
